import { render, staticRenderFns } from "./LogisticsTrace.vue?vue&type=template&id=e0425954&scoped=true&"
import script from "./LogisticsTrace.vue?vue&type=script&lang=js&"
export * from "./LogisticsTrace.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsTrace.vue?vue&type=style&index=0&id=e0425954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0425954",
  null
  
)

export default component.exports